import React, { useState } from "react";
import { Link } from "react-router-dom";
import { MailCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import api, { formatApiError } from "@/lib/api";

export default function ForgotPassword() {
  const [identifier, setIdentifier] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { identifier });
      setSent(true);
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center p-6 bg-slate-50">
      <div className="w-full max-w-sm" data-testid="forgot-password-page">
        <h1 className="font-heading text-2xl font-bold text-slate-900">Forgot password</h1>
        {sent ? (
          <div className="mt-6 rounded-2xl bg-white border border-slate-200 p-5" data-testid="forgot-sent">
            <MailCheck className="h-6 w-6 text-emerald-600" />
            <p className="mt-3 text-sm text-slate-700">If this account has an email on file, we've sent a reset link. It expires in 30 minutes.</p>
            <p className="mt-3 text-xs text-slate-500">Didn't get it? Check spam, or contact Zealous Ventures and we'll reset it for you.</p>
          </div>
        ) : (
          <>
            <p className="text-slate-500 text-sm mt-1 mb-6">Enter your email or phone number and we'll email you a reset link.</p>
            <form onSubmit={submit} className="space-y-4">
              <div>
                <Label htmlFor="fp-identifier">Email / Phone number</Label>
                <Input id="fp-identifier" data-testid="forgot-identifier" value={identifier} onChange={(e) => setIdentifier(e.target.value)} required className="mt-1.5 h-11" />
              </div>
              {error && <div className="text-sm text-rose-600" data-testid="forgot-error">{error}</div>}
              <Button type="submit" disabled={loading} className="w-full h-11 rounded-full bg-slate-900 hover:bg-black text-white" data-testid="forgot-submit">
                {loading ? "Sending..." : "Send reset link"}
              </Button>
            </form>
          </>
        )}
        <p className="text-sm text-slate-500 mt-6 text-center">
          <Link to="/login" className="text-amber-600 font-medium hover:underline" data-testid="forgot-back-login">Back to sign in</Link>
        </p>
      </div>
    </div>
  );
}
